import Vue from 'vue'
// import axios from 'axios'

import App from './App'
import router from './router'
import store from './store'
import '@/assets/js/flexible'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import vuescroll from 'vuescroll'
import 'vuescroll/dist/vuescroll.css'

import certificateManagement from '@/api/certificate-management'

import AppLayout from '@/components/layout/layout'
import AppHeader from '@/components/layout/layout-header'
Vue.component('app-layout', AppLayout)
Vue.component('app-header', AppHeader)

import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
 
Vue.use(VideoPlayer)


Vue.config.productionTip = false

Vue.use(Antd)

Vue.use(vuescroll, {
  ops: {
    vuescroll: {
      mode: 'native'
    },
    rail: {
      background: '#000',
      opacity: 0.3,
      size: '6px',
      specifyBorderRadius: false,
      gutterOfEnds: null,
      gutterOfSide: '2px',
      keepShow: false
    },
    bar: {
      showDelay: 500,
      onlyShowBarOnScroll: true,
      keepShow: false,
      background: '#0a0a0a',
      opacity: 1,
      hoverStyle: false,
      specifyBorderRadius: false,
      minSize: false,
      size: '6px',
      disable: false
    }
  }
})

// if (!process.env.IS_WEB) Vue.use(require('vue-electron'))
// Vue.http = Vue.prototype.$http = axios
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  components: { App },
  router,
  store,
  template: '<App/>'
}).$mount('#app')

// var {ipcRenderer, ipcRender} =require('electron');
// // 渲染进程接收:
// // ipcRenderer.on('cpu',function(event,data){
// //   console.log(data,'通信后，主进程传来hardware');
// //   // 写入localstorage
// // })
// ipcRenderer.on('system',function(event,data){
//   console.log(data,'通信后，主进程传来system');
//   // 写入localstorage
//   // const uuid = data.uuid;
//   // const serial = data.serial;
//   localStorage.setItem('uuid', data.uuid)
//   localStorage.setItem('serial', data.serial)

// })

// const links = document.querySelectorAll('a[href]');

// links.forEach(link => {

//   link.addEventListener('click', e => {

//     const url = link.getAttribute('href');

//     e.preventDefault();

//     ipcRender.send('open-url', url);

//   });

// });

// ipcRenderer.on('logout',function(event,data){
//   console.log(data)
//   certificateManagement.logout();
//   router.push("/login");
// })


router.beforeEach((to, from, next) => {
  if (to.matched.some(m => m.meta.auth)) {
    certificateManagement.checkLoginStatus().then((isLogin) => {
      if (isLogin) {
        next()
      } else {
        next({
          path: '/'
        })
      }
    })
  } else {
    next()
  }
})
